"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileDropdownOptionsPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../../Theme/constant");

var MobileDropdownOptionsPropTypes = {
  PropTypes: {
    options: _propTypes.default.shape({
      title: _propTypes.default.string.isRequired,
      subtitle: _propTypes.default.string,
      value: _propTypes.default.any.isRequired
    }),
    optionsConfig: _propTypes.default.arrayOf({
      icon: _propTypes.default.string,
      iconColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      titleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      subtitleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      bold: _propTypes.default.bool,
      separator: _propTypes.default.bool
    }),
    selectedItem: _propTypes.default.string,
    markSelectedOnPress: _propTypes.default.func,
    theme: _propTypes.default.string,
    customProperties: _propTypes.default.object
  },
  DefaultProps: {
    selectedItem: false,
    theme: _constant.DEFAULT_THEME,
    markSelectedOnPress: function markSelectedOnPress() {},
    customProperties: {}
  }
};
exports.MobileDropdownOptionsPropTypes = MobileDropdownOptionsPropTypes;